import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useWindowSize from '../../hooks/useWindowSize';
import { frontendSkills, mobileSkills, backendSkills, devToolsSkills, aiToolsSkills, familiarWithSkills } from '../../data/skills';
import useInView from '../../hooks/useInView';

const skillsMap = {
    frontend: frontendSkills,
    mobile: mobileSkills,
    backend: backendSkills,
    devTools: devToolsSkills,
    aiTools: aiToolsSkills,
    familiarWith: familiarWithSkills,
};

const Skills = () => {
    const { t, i18n } = useTranslation();
    const [ref, isInView] = useInView();
    const [activeTab, setActiveTab] = useState('frontend');
    const windowSize = useWindowSize();

    const isRtl = i18n.language === 'he';
    const isLargeScreen = windowSize > 991;

    const renderSkills = (value) => {
        const skills = skillsMap[value] || [];
        return skills.map((skill) => (
            <div key={skill._id} className='col-4 col-md-3 col-lg-2'>
                <div className='skill-item'>
                    {skill.icon}
                    <h6 className='skill-title'>{t(skill.name)}</h6>
                </div>
            </div>
        ));
    };

    return (
        <section id='skills'>
            <div className='container-xxl'>
                <div className='text-center'>
                    <h3 className='section-title'>
                        <span className={`${isRtl ? 'text-primary' : 'text-secondary'}`}>
                            {t('skills-title.part1')}
                        </span>
                        <span className={`${isRtl ? 'text-secondary' : 'text-primary'}`}>
                            {' '}
                            {t('skills-title.part2')}
                        </span>
                    </h3>
                </div>

                <div
                    ref={ref}
                    className={`row px-3 ${isInView ? 'fade-up' : ''} ${isLargeScreen ? '' : 'text-center'}`}
                >
                    <div className='col-lg-4 col-md-12 mt-2 mb-4 mt-lg-3 mb-lg-3 p-0'>
                        {isLargeScreen ? (
                            <div className='list-group'>
                                <button
                                    type='button'
                                    className={`list-group-item list-group-item-action ${
                                        activeTab === 'frontend' ? 'active' : ''
                                    }    `}
                                    onClick={() => setActiveTab('frontend')}
                                >
                                    {t('skill-list-group-title-1')}
                                </button>
                                <button
                                    type='button'
                                    className={`list-group-item list-group-item-action ${
                                        activeTab === 'mobile' ? 'active' : ''
                                    }    `}
                                    onClick={() => setActiveTab('mobile')}
                                >
                                    {t('skill-list-group-title-2')}
                                </button>
                                <button
                                    type='button'
                                    className={`list-group-item list-group-item-action ${
                                        activeTab === 'backend' ? 'active' : ''
                                    }    `}
                                    onClick={() => setActiveTab('backend')}
                                >
                                    {t('skill-list-group-title-3')}
                                </button>
                                <button
                                    type='button'
                                    className={`list-group-item list-group-item-action ${
                                        activeTab === 'devTools' ? 'active' : ''
                                    }    `}
                                    onClick={() => setActiveTab('devTools')}
                                >
                                    {t('skill-list-group-title-4')}
                                </button>

                                <button
                                    type='button'
                                    className={`list-group-item list-group-item-action ${
                                        activeTab === 'aiTools' ? 'active' : ''
                                    }    `}
                                    onClick={() => setActiveTab('aiTools')}
                                >
                                    {t('skill-list-group-title-5')}
                                </button>

                                <button
                                    type='button'
                                    className={`list-group-item list-group-item-action ${
                                        activeTab === 'familiarWith' ? 'active' : ''
                                    }    `}
                                    onClick={() => setActiveTab('familiarWith')}
                                >
                                    {t('skill-list-group-title-6')}
                                </button>
                            </div>
                        ) : (
                            <div className='btn-group mb-3'>
                                <button
                                    type='button'
                                    className={`btn btn-outline-primary ${
                                        activeTab === 'frontend' ? 'active' : ''
                                    }    `}
                                    onClick={() => setActiveTab('frontend')}
                                >
                                    {t('skill-list-group-title-1')}
                                </button>
                                <button
                                    type='button'
                                    className={`btn btn-outline-primary ${activeTab === 'mobile' ? 'active' : ''}    `}
                                    onClick={() => setActiveTab('mobile')}
                                >
                                    {t('skill-list-group-title-2')}
                                </button>
                                <button
                                    type='button'
                                    className={`btn btn-outline-primary ${activeTab === 'backend' ? 'active' : ''}    `}
                                    onClick={() => setActiveTab('backend')}
                                >
                                    {t('skill-list-group-title-3')}
                                </button>
                                <button
                                    type='button'
                                    className={`btn btn-outline-primary ${
                                        activeTab === 'devTools' ? 'active' : ''
                                    }    `}
                                    onClick={() => setActiveTab('devTools')}
                                >
                                    {t('skill-list-group-title-4')}
                                </button>
                                <button
                                    type='button'
                                    className={`btn btn-outline-primary ${
                                        activeTab === 'aiTools' ? 'active' : ''
                                    }    `}
                                    onClick={() => setActiveTab('aiTools')}
                                >
                                    {t('skill-list-group-title-5')}
                                </button>
                                <button
                                    type='button'
                                    className={`btn btn-outline-primary ${
                                        activeTab === 'familiarWith' ? 'active' : ''
                                    }    `}
                                    onClick={() => setActiveTab('familiarWith')}
                                >
                                    {t('skill-list-group-title-6')}
                                </button>
                            </div>
                        )}
                    </div>
                    <div className='col-lg-8 col-md-12'>
                        <div className='row'>{renderSkills(activeTab)}</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Skills;
